import { inject, Injectable } from '@angular/core';
import { mockStatusMessageDetailPage, mockStatusMessagePollingResponse } from '../../common/utils/api-mocks';
import { PayloadFilter, ToastMessagePollingResponse } from './status-message.model';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseService } from '../../common/services/base-service';
import { API_PATHS } from '../../common/constants/api-paths';

@Injectable({
    providedIn: 'root',
})
export class StatusMessageService{

  private readonly baseService = inject(BaseService);

  private readonly toastCountSubject = new BehaviorSubject<number>(0);
  toastCount$ = this.toastCountSubject.asObservable();

  setToastCount(count: number): void {
    this.toastCountSubject.next(count);
  }

  getToastMessagePollingResponse(filters?: PayloadFilter, search?: string, hideLoader?: boolean, pageNumber?: number, pageSize?: number): Observable<ToastMessagePollingResponse> {
    if(!environment.STUBS) {
      return mockStatusMessagePollingResponse();
    } else {
      try {
        const payload = {
          pageNumber: pageNumber ?? 1,
          pageSize: pageSize ?? 10,
          search: search ?? '',
          filters: filters,
        };
        return from(this.baseService.post<ToastMessagePollingResponse>(API_PATHS.STATUS_MESSAGES.GET_STATUS_MESSAGES, payload, null, hideLoader));
      } catch(e) {
        return new Observable(observer => observer.error(e));
      }
    }
  }

  updateStatusMessageStatus(messageIdList: string[], isRead: boolean, isNotified: boolean): Observable<any> {
    if(!environment.STUBS) {
      return new Observable(observer => observer.error(new Error()));
    } else {
      try {
        const payload = {
          messageId: messageIdList,   //required
          isRead: isRead, //(Boolean) //optional
          isNotified: isNotified //optional (Note: Either one of isRead or isNotified is required)
        };
        return from(this.baseService.post<any>(API_PATHS.STATUS_MESSAGES.UPDATE_STATUS_MESSAGES, payload, null, true));
      } catch(e) {
        return new Observable(observer => observer.error(e));
      }
    }
  }

  getStatusMessageDetails(payload: {serviceMessageName: string}): Observable<any> {
    if(!environment.STUBS) {
      return mockStatusMessageDetailPage();
    } else {
      try {
        return from(this.baseService.post<any>(API_PATHS.STATUS_MESSAGES.STATUS_MESSAGE_DETAILS, payload, null));
      } catch(e) {
        return new Observable(observer => observer.error(e));
      }
    }
  }
}